import { computed } from 'vue'

export default ({ unreadTotal }) => ({
  hasUnread: computed(() => unreadTotal.value > 0)
})
